// Cookie consent manager for Eternal City View
// Stores user choice in localStorage and syncs with Google Consent Mode v2 + PostHog.

const STORAGE_KEY = "ecv_cookie_consent";
const VERSION = 1;

export function readConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const obj = JSON.parse(raw);
    if (!obj || obj.version !== VERSION) return null;
    return obj;
  } catch {
    return null;
  }
}

export function saveConsent({ analytics }) {
  const payload = {
    version: VERSION,
    necessary: true,
    analytics: !!analytics,
    timestamp: new Date().toISOString(),
  };
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(payload));
  } catch {}
  applyConsent(payload);
  return payload;
}

export function applyConsent(consent) {
  if (typeof window === "undefined") return;
  const analyticsGranted = !!(consent && consent.analytics);

  // Google Consent Mode v2 update
  if (typeof window.gtag === "function") {
    try {
      window.gtag("consent", "update", {
        analytics_storage: analyticsGranted ? "granted" : "denied",
        ad_storage: "denied",
        ad_user_data: "denied",
        ad_personalization: "denied",
      });
    } catch {}
  }

  // PostHog
  if (window.posthog && typeof window.posthog.opt_in_capturing === "function") {
    try {
      if (analyticsGranted) {
        window.posthog.opt_in_capturing();
      } else {
        window.posthog.opt_out_capturing();
      }
    } catch {}
  }
}

export function hasDecision() {
  return readConsent() !== null;
}

export function resetConsent() {
  try { localStorage.removeItem(STORAGE_KEY); } catch {}
}
